
<div id="alerta-inicio" *ngIf="mainContainerService.listOcorrenciasRoteiroStatus.length == 0">
    <i class="fa fa-arrow-left"></i> Selecione algum roteiro na lista ao lado para iniciar
</div>
<div id="roteiro-selecionado" *ngIf="mainContainerService.listOcorrenciasRoteiroStatus.length > 0">
    <button id="btnAbreOcRoteiroBuscaRadar" (click)="abreOcRoteiroBuscaRadar()" hidden=true data-toggle="modal" data-target="#popup-ocorrencia" ></button>
    <img src="assets/imgs/icon-eye.svg">
    <div class="titulo">
        <h1>Roteiro {{ mainContainerService.listOcorrenciasRoteiroStatus[0].roteiro }} </h1>
        <h2>
            <span title="Previsão de Saída">
                <i class="fa fa-calendar"></i>
                {{ util.converteData(mainContainerService.listOcorrenciasRoteiroStatus[0].PrevisaoSaida) | date: 'dd/MM/yyyy HH:mm' }}
            </span>
            <span title="Veículo">
                <i class="fa fa-bus"></i>
                {{ mainContainerService.listOcorrenciasRoteiroStatus[0].cod_veiculo }} {{ mainContainerService.listOcorrenciasRoteiroStatus[0].veiculo
                }}
            </span>
            <span title="Motorista">
                <i class="fa fa-user"></i> {{ mainContainerService.listOcorrenciasRoteiroStatus[0].nome_motorista }}
            </span>
            <span *ngIf="mainContainerService.listOcorrenciasRoteiroStatus[0].ContatoMotorista" title="Contato do Motorista">
                <i class="fa fa-phone"></i> 
                {{ mainContainerService.listOcorrenciasRoteiroStatus[0].ContatoMotorista }}
            </span>
        </h2>
    </div>

</div>

<div id="ocorrencias-colunas" *ngIf="mainContainerService.listOcorrenciasRoteiroStatus.length > 0">
    <app-modal-avaliacao [momento]="'ENCERRAR'" *ngIf="avaliacaoService.exibirModalAvaliacao" (closeModal)="fecharModal()"></app-modal-avaliacao>

    <div id="OcorrenciasEmAberto" class="ocorrencias em-aberto">
        <h3>
            <img class="icon" src="assets/imgs/exclamation-circle.svg" alt="">Em aberto ({{ mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.novo.length ?? 0 }})</h3>
        <ul class="ocorrencias-col">
            <li class="ocorrencia-item" *ngIf="mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.novo.length > 0">
                <button data-toggle="modal" data-target="#popup-ocorrencia" *ngFor="let novo of mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.novo"
                    (click)="visualizarOcorrencia(novo)">
                    <div class="conteudo">
                        <img class="icone" [src]="novo.CodigoCliente == null ? 'assets/imgs/rotaplan-gps-acao-problema-veiculo.svg' : 'assets/imgs/rotaplan-gps-acao-problema-cliente.svg'"
                            title="Ocorrência fora do cliente">
                        <div class="dados">
                            <header class="motivo">
                                {{ novo.Motivo }}
                                <span class="oc-codigo"><i class="fa fa-tag"></i> {{ novo.CodigoOcorrencia }}</span>
                            </header>
                            <span class="nome-fantasia" *ngIf="novo.NomeFantasia"><i class="fa fa-home"></i> {{ novo.NomeFantasia }} ({{ novo.CodigoCliente }})</span>                            
                            <div class="data"><i class="fa fa-clock-o"></i> {{ util.converteData(novo.Data) | date: 'dd/MM/yyyy | HH:mm' }}</div>
                        </div>
                    </div>
                </button>
            </li>
        </ul>
    </div>
    <div id="OcorrenciasEmAnalise" class="ocorrencias em-analise">
        <h3>
            <img class="icon" src="assets/imgs/clock-history.svg" alt="">
                Em avaliação ({{ mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.analise.length }}) 
            <button id="btnCriarNova" class="nova-ocorrencia" data-toggle="modal" data-target="#nova-ocorrencia"><img src="assets/imgs/plus-lg.svg" alt="" >Criar nova </button>
            <button (click)="visualizarOcorrenciaAlerta()"  id="btnConsultarOcorrencia" data-toggle="modal"  data-target="#popup-ocorrencia" hidden="true"></button>
        </h3>
        <ul class="ocorrencias-col">
            <li class="ocorrencia-item" *ngIf="mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.analise.length > 0">
                <button data-toggle="modal" data-target="#popup-ocorrencia" *ngFor="let analise of mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.analise"
                    (click)="visualizarOcorrencia(analise)" [class.ativado]='analise.CodigoOcorrencia == util.ocorrenciaAlterada' >
                    <div class="conteudo">
                            <img class="icone" [src]="analise.CodigoCliente == null ? 'assets/imgs/rotaplan-gps-acao-problema-veiculo.svg' : 'assets/imgs/rotaplan-gps-acao-problema-cliente.svg'"
                            title="Ocorrência no cliente">
                        <div class="dados">
                            <header class="motivo">{{ analise.Motivo }} <span class="oc-codigo">
                                <i class="fa fa-tag"></i> {{ analise.CodigoOcorrencia }}</span> 
                            </header>                            
                            <div class="nome-fantasia" *ngIf="analise.NomeFantasia"><i class="fa fa-home"></i> {{ analise.NomeFantasia }} ({{ analise.CodigoCliente }})</div>
                            <div class="data"><i class="fa fa-clock-o"></i> {{ util.converteData(analise.Data) | date: 'dd/MM/yyyy | HH:mm' }}</div>
                        </div>
                    </div>
                </button>
            </li>

        </ul>
    </div>
    <div id="OcorrenciasFinalizadas" class="ocorrencias finalizadas">
        <h3>
            <img class="icon" src="assets/imgs/check-circle.svg" alt="">Finalizadas ({{ mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.finalizado.length
            }})
        </h3>
        <ul class="ocorrencias-col">
            <li class="ocorrencia-item" *ngIf="mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.finalizado.length > 0">
                <button data-toggle="modal"  [class.ativado]='finalizado.CodigoOcorrencia == util.ocorrenciaAlterada' data-target="#popup-ocorrencia" *ngFor="let finalizado of mainContainerService.listOcorrenciasRoteiroStatus[0].qtdOcorrenciasPorStatus.finalizado"
                    (click)="visualizarOcorrencia(finalizado)">
                    <div class="conteudo">
                        <img class="icone" [src]="finalizado.CodigoCliente == null ? 'assets/imgs/rotaplan-gps-acao-problema-veiculo.svg' : 'assets/imgs/rotaplan-gps-acao-problema-cliente.svg'"
                            title="Ocorrência no cliente">
                        <div class="dados">
                            <header class="motivo">{{ finalizado.Motivo }}
                                <span class="oc-codigo"><i class="fa fa-tag"></i> {{ finalizado.CodigoOcorrencia }}</span>
                            </header>
                            <span class="nome-fantasia" *ngIf="finalizado.NomeFantasia"><i class="fa fa-home"></i> {{ finalizado.NomeFantasia }} ({{ finalizado.CodigoCliente }})</span>
                            <div class="data"><i class="fa fa-clock-o"></i> {{ util.converteData(finalizado.Data) | date: 'dd/MM/yyyy | HH:mm' }}</div>
                        </div>
                    </div>
                </button>
            </li>
        </ul>
    </div>
</div>